import { createStyles, makeStyles } from '@material-ui/core'
import styled from 'styled-components'
import MttButton from 'components/Material/MttButton/MttButton'
import MttGrid from 'components/Material/MttGrid/MttGrid'
import MttTypography from '../Material/MttTypography/MttTypography'
import Typography from '../Typography'
const drawerWidth = 300

export const ModalButton = styled(MttButton)`
  width: 325px;
  height: 51px;
  border-radius: 8px;
  padding: 10px;
  margin-top: 10px;
`

export const StyledButton = styled.div`
  .MuiButton-label {
    display: block;
    padding: 8px;
    line-height: normal;
  }

  .MuiButton-startIcon {
    margin: 0;
    margin-bottom: 10px;
  }
`

export const StyledButtonSend = styled.div`
  .MuiButton-label {
    display: block;
    padding: 8px;
    line-height: normal;
  }

  .MuiButton-startIcon {
    margin: 0;
    transform: rotateY(180deg);
  }
`

export const DialogContent = styled(MttGrid)`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 8px;

  .defaultButtonStyle {
    width: 110px;
    height: 99px;
    border-radius: 8px;
    padding: 0;
    margin: 4px;
    text-transform: none;
    font-weight: bold;
    font-size: 16px;
  }
`

export const ContainerDivider = styled.div`
  margin: 4px;
`

export const TitleTypography = styled(MttTypography).attrs({
  children: 'Que tipo de bloco deseja criar?',
  variant: 'h6',
  color: 'primary',
})``

export const ContainerHeader = styled(MttGrid)`
  display: flex;
  margin-left: 16px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const ModalTitle = styled(Typography).attrs({
  variant: 'h6',
})`
  color: #0e103b;
`

export const CloseButtonGrid = styled(MttGrid)`
  position: absolute;
  top: 21px;
  right: 21px;

  justify-content: space-around;
  color: #707070;
  display: flex;
  cursor: pointer;
`

export const GridFluxoInicial = styled(MttGrid).attrs({
  className: 'greenButtonMaterial',
})``

export const GridButtonAzulClaro = styled(MttGrid).attrs({
  className: 'lightBlueButtonMaterial',
})``

export const GridButtonAzulEscuro = styled(MttGrid).attrs({
  className: 'darkBlueButtonMaterial',
})``

export const GridButtonLaranja = styled(MttGrid).attrs({
  className: 'orangeButtonMaterial',
})``

export const StyledMttButton = styled(MttButton).attrs({
  className: 'defaultButtonStyle',
})``

export const useStyles = makeStyles((theme) =>
  createStyles({
    listItem: {
      color: '#424242 !important',
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
      width: '100%',
      '& svg': {
        width: '20px',
        height: '20px',
        marginRight: '0',
        flexShrink: 0,
      },
      '& .MuiTypography-root': {
        fontSize: '14px',
        fontWeight: 400,
      },
    },

    listSvg: {
      marginRight: '20px',
    },

    root: {
      display: 'flex',
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: 36,
    },
    hide: {
      display: 'none',
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: 'nowrap',
      position: 'absolute',
    },
    drawerOpen: {
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginTop: '165px',
      marginLeft: '54px',
      zIndex: 'auto',
    },
    toolbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    accordionSummary: {
      minHeight: '24px !important',
      '& .MuiAccordionSummary-content.Mui-expanded': {
        margin: 0,
      },
    },
    accordion: {
      boxShadow: 'none',
      '& .MuiPaper-elevation1': {
        boxShadow: 'none',
      },
    },
    accordionContent: {
      padding: '0 0 8px 0',
      maxHeight: '276px',
      overflowY: 'scroll',
    },

    dialogTitle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: theme.spacing(2, 3),
      backgroundColor: '#fafafa',
      '& h6': {
        fontWeight: 500,
      },
    },
    closeButton: {
      color: '#9e9e9e',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
    dialogContent: {
      display: 'flex',
      flexDirection: 'column',
      height: '550px',
      padding: 0,
    },
    searchContainer: {
      padding: theme.spacing(2, 3),
      backgroundColor: '#ffffff',
      borderBottom: `1px solid ${theme.palette.divider}`,
      flexShrink: 0,
    },
    blockList: {
      flex: 1,
      overflowY: 'auto',
      padding: 0,
      boxShadow: 'none',
    },
    itemsList: {
      width: '100%',
      padding: theme.spacing(1, 0, 2, 0),
    },
    blockItem: {
      padding: theme.spacing(1.2, 3),
      borderRadius: '4px',
      margin: theme.spacing(0.5, 0),
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
      '& .MuiTypography-root': {
        fontSize: '14px',
      },
      '&.Mui-disabled': {
        opacity: 0.6,
      },
      '& .MuiListItemIcon-root': {
        minWidth: 'auto',
        width: '100%',
        margin: 0,
      },
    },
    emptyStateContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(6, 2),
      textAlign: 'center',
      height: '100%',
      minHeight: '300px',
    },
    emptyStateIcon: {
      fontSize: '48px',
      color: 'rgba(0, 0, 0, 0.26)',
      marginBottom: theme.spacing(2),
      border: '2px dashed rgba(0, 0, 0, 0.26)',
      borderRadius: '8px',
      padding: theme.spacing(2),
    },
    emptyStateTitle: {
      fontWeight: 600,
      color: 'rgba(0, 0, 0, 0.87)',
      marginBottom: theme.spacing(1),
    },
    emptyStateDescription: {
      color: 'rgba(0, 0, 0, 0.54)',
      maxWidth: '280px',
    },
    searchField: {
      '& .MuiOutlinedInput-root': {
        backgroundColor: '#ffffff',
        fontSize: '14px',
        borderRadius: '8px',
        height: '48px',
        '& fieldset': {
          borderColor: 'rgba(0, 0, 0, 0.12)',
          borderWidth: '1px',
        },
        '&:hover fieldset': {
          borderColor: 'rgba(0, 0, 0, 0.25)',
        },
        '&.Mui-focused fieldset': {
          borderColor: '#F06292',
          borderWidth: '2px',
        },
        '& .MuiInputBase-input': {
          padding: '12px 14px 12px 4px',
          height: '24px',
          '&::placeholder': {
            color: 'rgba(0, 0, 0, 0.5)',
            opacity: 1,
          },
        },
        '& .MuiInputAdornment-root': {
          color: 'rgba(0, 0, 0, 0.5)',
          marginLeft: '4px',
        },
        '& .MuiInputAdornment-positionStart svg': {
          fontSize: '20px',
        },
        '& .MuiInputAdornment-positionEnd svg': {
          fontSize: '20px',
        },
      },
    },
    clearButton: {
      padding: '4px',
      color: 'rgba(0, 0, 0, 0.5)',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
        color: 'rgba(0, 0, 0, 0.7)',
      },
      '& svg': {
        fontSize: '16px',
      },
    },
    categoryHeader: {
      backgroundColor: 'rgba(240, 98, 146, 0.08)',
      padding: theme.spacing(1.5, 0),
      pointerEvents: 'none',
      marginTop: theme.spacing(2),
      '&:first-child': {
        marginTop: theme.spacing(1),
      },
    },
    categoryHeaderText: {
      fontWeight: 600,
      color: '#F06292',
      fontSize: '13px',
      textTransform: 'uppercase',
      letterSpacing: '0.8px',
      marginLeft: theme.spacing(3),
    },
  }),
)
